import { mediaQuery } from '@/styles/media';
import styled from 'styled-components';

const ExternalLink = styled.a`
  display: block;

  img {
    width: 100%;
  }
`;

const Image = styled.img<{ width: number }>`
  ${mediaQuery.tb} {
    height: auto;
    width: 100%;
    min-width: ${(props) => props.width};
  }
`;

type Props = {
  href: string;
  alt: string;
  imgUrl: string;
  width?: number;
  height: number;
};

const SidebarImage: React.FC<Props> = ({
  href,
  alt,
  imgUrl,
  width = 310,
  height,
}) => (
  <ExternalLink href={href} target="_blank" rel="noopener noreferrer">
    <Image src={imgUrl} alt={alt} width={width} height={height} />
  </ExternalLink>
);

export default SidebarImage;
